export default function getPlatformCode(
  type: string
): number {
    const buffer = Buffer.from(type.replace(/:/g, ''), 'hex')

    const code = buffer.readUInt16BE(8)
    
    return code;
}
